<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-layout class="ml-4 mr-4">
			<v-btn
				v-if="['FINAL_EVALUATION', 'FINISHED'].includes(contestData.contestStatus) && (['SECRETARY', 'MAIN_SECRETARY'].includes(userDomainRole) || roles.isAdministrator() || roles.isLocalAdministrator())"
				@click="generateProjects">
				<v-icon class="mr-2">star</v-icon>
				Wygeneruj projekty
			</v-btn>
			<v-spacer></v-spacer>
			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" color="primary" dark>
						<v-icon class="icon-export-offers" left>save</v-icon>
						Eksport formularzy
					</v-btn>
				</template>

				<v-list>
					<v-list
						v-for="(item, index) in exportMenu"
						:key="index">
						<v-list-tile @click="openModal(item.type)">{{ item.label }}</v-list-tile>
					</v-list>
				</v-list>
			</v-menu>
			<v-btn
				v-if="contestData.contestStatus !== 'ANNOUNCED' && (['SECRETARY', 'MAIN_SECRETARY'].includes(userDomainRole) || roles.isAdministrator() || roles.isLocalAdministrator())"
				color="accent"
				@click="manageCommittees(contestData)">
				<v-icon left>assignment</v-icon>
				Oferty w komisjach
			</v-btn>
		</v-layout>

		<v-alert :value="initialized && !placingOfferAllowed" type="warning">
			Konkurs poza terminem naboru ofert.
		</v-alert>
		<v-alert :value="highScoreDifference" class="lightred" type="warning">
			Rozbieżność ocen w ofertach: {{ warningCodes.join(", ") }}
		</v-alert>

		<v-layout align-center class="mt-2 mb-2" justify-center>
			<v-flex xs2>
				<v-text-field
					v-model="search.offerCode"
					browser-autocomplete="off"
					class="ma-2"
					aria-label="offer code"
					label="Numer oferty">
				</v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-text-field
					v-model="search.evaluating"
					browser-autocomplete="off"
					class="ma-2"
					aria-label="evaluator"
					label="Oceniający">
				</v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					v-model="search.countryId"
					:items="availableCountries"
					class="ma-2"
					clearable
					aria-label="country"
					item-text="name"
					item-value="id"
					label="Kraj">
				</v-autocomplete>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					v-model="search.committeeId"
					:items="availableCommittees"
					class="ma-2"
					clearable
					aria-label="committee"
					item-text="name"
					item-value="id"
					label="Komisja">
				</v-autocomplete>
			</v-flex>
			<v-flex xs1>
				<v-layout align-center justify-center>
					<v-btn
						color="primary"
						@click="resetSearch">
						Resetuj
					</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<offers-list
			v-if="inclusionStatuses !== null"
			ref="offerList"
			:bidder-name-visible="true"
			:contest-id="contestData.id"
			:expansion-disabled="isOfferWithoutAnyEvaluation"
			:inclusion-statuses="inclusionStatuses"
			:is-expandable="true"
			:is-paginated="true"
			:not-qualified-offers-ids="offersBelowQualification.map(offer => offer.id)"
			:offers="offers"
			:search="search"
			:show-evaluation-stats="true"
			:warning-codes="warningCodes"
			empty-warning="W tym konkursie nie ma jeszcze ofert"
			header="Opiniowanie ofert">

			<template v-slot:expandableArea="slotData" v-if="contestData.contestStatus">
				<offer-evaluation-sublist :final-evaluation-sharing-disabled="evaluationSharingDisabled()"
					:offer="slotData.offer"
					:user-domain-role="userDomainRole"
					:contest-status="contestData.contestStatus"
					:boolean-evaluation="ratingSettings.booleanEvaluation"
					@formal-evaluation-removed="formalEvaluationRemoved"
					@substantive-evaluation-removed="substantiveEvaluationRemoved"
					@final-evaluation-removed="finalEvaluationRemoved"
					@expert-evaluation-removed="expertEvaluationRemoved"
					@agency-evaluation-removed="agencyEvaluationRemoved"
					@update-warning-codes="prepareWarningCodes"
					@bidder-preview-changed="finalEvaluationBidderPreviewChanged"
					@final-evaluation-correction-requested="finalEvaluationCorrectionRequested"
				/>
			</template>

			<template v-slot:extraAction="slotData">
				<v-list-tile-action>
					<egranty-icon-button
						v-if="slotData.offer.offerStatus === 'REJECTED'"
						id="contest-offer-list-view-restore-offer"
						:disabled="restoringDisabled()"
						color="primary"
						for="contest-offer-list-view-restore-offer"
						icon="block"
						label="Przywróć ofertę"
						@click="restoreOffer(slotData.offer)"/>
					<egranty-icon-button
						v-else
						id="contest-offer-list-view-discard-offer"
						:disabled="rejectionDisabled(slotData.offer)"
						color="lightred"
						for="contest-offer-list-view-discard-offer"
						icon="block"
						label="Odrzuć ofertę"
						@click="openRejectDialog(slotData.offer)"/>
				</v-list-tile-action>

				<v-list-tile-action>
					<egranty-icon-button
						v-if="undoRequestAvailable(slotData.offer)"
						id="contest-offer-list-view-undo-correct"
						:disabled="isNotSecretaryOrLeader()"
						color="warning"
						for="contest-offer-list-view-undo-correct"
						icon="cancel"
						label="Cofnij oddanie do poprawek"
						@click="undoRequestChanges(slotData.offer)"/>
					<egranty-icon-button
						v-else
						id="contest-offer-list-view-give-to-correct"
						:disabled="correctionDisabled(slotData.offer)"
						color="primary"
						for="contest-offer-list-view-give-to-correct"
						icon="build"
						label="Oddaj do poprawek"
						@click="openCorrectDialog(slotData.offer)"/>
				</v-list-tile-action>

				<assign-for-opinions-menu
					:committee-not-assigned="!slotData.offer.committeeId"
					:contest-evaluation-not-allowed="!['EVALUATION', 'FINAL_EVALUATION'].includes(contestData.contestStatus)"
					:contest-id="contestData.id"
					:inclusion-statuses="inclusionStatuses"
					:no-access="isNotSecretaryOrLeader()"
					:offer="slotData.offer"
					:offer-evaluation-not-allowed="slotData.offer.offerStatus !== 'SUBMITTED'"
					@evaluation-assigned="reloadContestOffers"/>

				<v-list-tile-action>
					<egranty-icon-button
						id="contest-offer-list-view-confirm"
						:color="'blue'"
						:disabled="slotData.offer.offerStatus !== 'RESERVED'"
						for="contest-offer-list-view-confirm"
						icon="star"
						label="Zatwierdź do realizacji"
						@click="approveOffer(slotData.offer)"/>
				</v-list-tile-action>
			</template>
		</offers-list>

		<egranty-input-field-popup
			id="contest-offer-list-view-reason-for-rejecton"
			:is-open.sync="dialogsState.rejectCause.open"
			:long="true"
			field-type="LONG_TEXT"
			for="contest-offer-list-view-reason-for-rejecton"
			label="Powód odrzucenia oferty"
			title="Odrzucenie oferty"
			@save="rejectSelectedOffer">
		</egranty-input-field-popup>

		<v-dialog v-model="correction.dialog" max-width="1000px" persistent>
			<v-card>
				<v-card-title>
					<h3 class="headline">Przekazanie oferty do poprawek</h3>
				</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="correction.cause"
						v-validate="'required'"
						:error-messages="vErrors.collect('correctionCause')"
						browser-autocomplete="off"
						data-vv-as="Powód przekazania do poprawek"
						data-vv-name="correctionCause"
						label="Powód przekazania do poprawek"
						aria-label="correction cause"
						@keydown="onKeyDownEvent">
					</v-text-field>
					<v-textarea
						v-model="correction.detailedCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						browser-autocomplete="off"
						data-vv-as="Opis szczegółowy"
						data-vv-name="detailedCorrectionCause"
						label="Opis szczegółowy"
						v-validate="'required'"
						aria-label="detailed correction cause">
					</v-textarea>
					<egranty-date-picker
						v-model="correction.correctionDeadline"
						:min="todayString"
						label="Termin na przesłanie poprawek"
						aria-label="correction deadline">
					</egranty-date-picker>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correction.cause !== '' && correction.detailedCause !== ''"
						color="primary"
						flat
						@click="requestChanges">
						Wyślij
					</v-btn>
					<v-btn
						color="blue"
						@click="correction.dialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<offer-export-modal ref="offerExportModal"/>
		<evaluation-export-modal ref="evaluationExportModal"/>
	</div>
</template>

<script>
	import OffersList from "./components/OffersList";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import AssignForOpinionsMenu from "./components/AssignForOpinionsMenu";
	import OfferEvaluationSublist from "./components/OfferEvaluationSublist";
	import {Dates} from "@/utils/Dates";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {Offer} from "@/api/generated/Offer";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
	import {Initializator} from "@/utils/Initializator";
	import {Committee} from "@/api/generated/Committee";
	import {Project} from "@/api/generated/Project";
	import {TaskAccreditationCountry} from "@/api/generated/TaskAccreditationCountry";
	import OfferExportModal from "./components/OfferExportModal";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import {Api} from "@/api";
	import EvaluationExportModal from "./components/EvaluationExportModal";
	import {EvaluationSummary} from "@/api/generated/EvaluationSummary";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "ContestOfferListView",

		components: {
			EvaluationExportModal,
			OfferExportModal,
			EgrantyInputFieldPopup,
			OfferEvaluationSublist,
			AssignForOpinionsMenu,
			OffersList,
			EgrantyIconButton,
			EgrantyDatePicker,
		},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
					contestStatus: null,
				},
				dialogsState: {
					rejectCause: {
						open: false,
					},
					evaluationOpeningErrors: {
						open: false,
					},

					selectedOffer: null,
				},
				inclusionStatuses: null,
				contestTerms: {},
				ratingSettings: {},
				warningCodes: [],
				evaluationOpeningErrors: {},
				offers: null,
				offersBelowQualification: [],
				offersLoaded: false,
				correctionCausesLoaded: false,
				causesMatched: false,
				correction: {
					dialog: false,
					cause: "",
					detailedCause: "",
					correctionDeadline: null,
				},
				correctionCauses: [],
				availableCountries: [],
				availableCommittees: [],
				search: {
					countryId: null,
					committeeId: null,
					offerCode: "",
					evaluating: "",
				},
				offerCodes: [],
				userDomainRole: undefined,
				exportMenu: [
					{label: "Eksport ofert", type: "OFFER_EXPORT"},
					{label: "Eksport ocen", type: "EVALUATION_EXPORT"},
				],
			};
		},

		computed: {
			placingOfferAllowed() {
				return this.isInFuture(this.contestTerms.contestEndDateTime);
			},

			highScoreDifference() {
				return this.warningCodes.length !== 0;
			},

			todayString() {
				return this.getTodayString();
			},
		},

		async created() {
			await Api.get(this, "/public-contest/user-role?contestId=".concat(this.contestData.id), success => {
				this.userDomainRole = success;
			});
			this.reloadContestOffers();
			this.getCountries();
      this.search = this.retrieveFilters(this.search);
    },

		watch: {
			ratingSettings: function () {
				this.prepareWarningCodes();
			},
		},

		methods: {
			openEvaluationExportModal() {
        let expertEvaluationsNumber = Math.max(...this.$refs.offerList.offers.map(offer => offer.expertEvaluations.length));
				this.$refs.evaluationExportModal.openModal(this.$refs.offerList.offerCodes, expertEvaluationsNumber);
			},

			openOfferExportModal() {
				this.$refs.offerExportModal.openModal(this.$refs.offerList.offerCodes);
			},

			openModal(type) {
				switch (type) {
					case "EVALUATION_EXPORT":
						this.openEvaluationExportModal();
						break;
					case "OFFER_EXPORT":
						this.openOfferExportModal();
						break;
				}
			},

			onKeyDownEvent(evt) {
				if (this.correction.cause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) {
					evt.preventDefault();
				}
			},

      undoRequestAvailable(offer) {
        return offer.offerStatus === 'AWAITING_CORRECTION'
            || offer.offerStatus === 'POST_CORRECTION_MAIN'
            || offer.offerStatus === 'POST_CORRECTION_MUTUAL';
      },

			restoringDisabled() {
				return !["INITIAL_REJECTION_AND_COMMITTEE_ASSIGN", "EVALUATION", "FINAL_EVALUATION"].includes(this.contestData.contestStatus) ||
					!(this.roles.isAdministrator() || this.roles.isLocalAdministrator() ||
						(this.userDomainRole === "SECRETARY" || this.userDomainRole === "MAIN_SECRETARY" || this.userDomainRole === "LEADER" || this.userDomainRole === "MAIN_LEADER")
					);
			},
			rejectionDisabled(offer){
				return !["INITIAL_REJECTION_AND_COMMITTEE_ASSIGN", "EVALUATION", "FINAL_EVALUATION"].includes(this.contestData.contestStatus) ||
					!(this.roles.isAdministrator() || this.roles.isLocalAdministrator() ||
						(this.userDomainRole === "SECRETARY" || this.userDomainRole === "MAIN_SECRETARY" || this.userDomainRole === "LEADER" || this.userDomainRole === "MAIN_LEADER")
					) || offer.offerStatus === "APPROVED";
			},

      correctionDisabled(offer) {
        return ['FINAL_EVALUATION', 'FINISHED'].includes(this.contestData.contestStatus)
            || offer.offerStatus !== 'SUBMITTED' || this.isNotSecretaryOrLeader();
      },

			evaluationSharingDisabled() {
				return (this.roles.isDepartmentEmployee() || this.roles.isExpert()) &&
					(this.userDomainRole !== "SECRETARY" && this.userDomainRole !== "MAIN_SECRETARY");
			},

			generateProjects() {
				this.$confirm("Czy na pewno chcesz wygenerować projekty?", {
					icon: "warning",
					title: "Generowanie projektów",
					color: "info",
					width: 500,
				})
					.then(response => {
						if (response) {
							Project.post(this, this.contestData.id, successResponse => {
									this.updateOffersAfterProjectsGeneration(successResponse);
									this.$messagesBus.$emit("success", "Generowanie projektów zostało zakończone. Liczba wygenerowanych projektów: "+successResponse.length, successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się wygenerować projektów", errorResponse);
								});
						}
					});
			},

			manageCommittees(contest) {
				this.$router.push("/app/contest/" + contest.id + "/manage-committees");
			},

			reloadContestOffers() {
				this.loadContestOffers();
				this.loadCorrectionCauses();
				this.loadContestTerms();
				this.loadEvaluationFormsInclusionStatuses();
				this.loadContestStatus();
				this.loadAvailableCommittees();
			},

			openRejectDialog(offer) {
				this.dialogsState.selectedOffer = offer;
				this.dialogsState.rejectCause.open = true;
			},

			openCorrectDialog(offer) {
				this.dialogsState.selectedOffer = offer;
				this.correction.dialog = true;
			},

			restoreOffer(offer) {
				this.$confirm("Czy na pewno chcesz przywrócić ofertę?", {
					color: "blue",
					icon: "restore_page",
					title: "Przywracanie oferty",
				})
					.then(result => {
						if (result) {
							Offer.putRestoreOffer(this, offer.id, offer.offerStatus = "SUBMITTED");
						}
					});
			},

			requestChanges() {
				Offer.putRequestCorrection(
					this,
					this.dialogsState.selectedOffer.id,
					this.prepareData(),
					successResponse => {
						this.correction.dialog = false;
						this.offers
							.filter(o => o.id === this.dialogsState.selectedOffer.id)
							.map(o => {
								o.offerStatus = "AWAITING_CORRECTION";
								o.correctionCause = this.correction.cause;
								o.correctionDeadline = this.correction.correctionDeadline;
							});
						this.$messagesBus.$emit("success", "Pomyślnie oddano ofertę do poprawek", successResponse);
						this.correction.cause = "";
						this.correction.detailedCause = "";
						this.correction.correctionDeadline = null;
					},
				);
			},

      undoRequestChanges(offer) {
        this.$confirm("Czy na pewno chcesz wycofać oddanie oferty do poprawek?", {
          icon: "warning",
          title: "Cofnięcie oddania do poprawek",
          color: "info",
          width: 500,
        })
            .then(response => {
              if (response) {
                Offer.putUndoRequestCorrection(this, offer.id, successResponse => {
                      offer.offerStatus = "SUBMITTED";
                      offer.correctionCause = null;
                      offer.correctionDeadline = null;
                      this.$messagesBus.$emit("success", "Oferta została pomyślnie wycofana z poprawek", successResponse);
                    },
                    errorResponse => {
                      this.$messagesBus.$emit("error", "Nie udało się wycofać oferty z poprawek", errorResponse);
                    });
              }
            });
      },

      prepareData() {
				return {
					correctionCause: this.correction.cause,
					detailedCorrectionCause: this.correction.detailedCause,
					correctionDeadline: this.correction.correctionDeadline,
				};
			},

			rejectSelectedOffer (rejectCause) {
				Offer.postReject(this, this.dialogsState.selectedOffer.id, {body: rejectCause},
					successResponse => {
						this.dialogsState.rejectCause.open = false;
						this.offers
							.filter(o => o.id === this.dialogsState.selectedOffer.id)
							.map(o => {
								o.offerStatus = "REJECTED";
								o.rejectCause = rejectCause;
							});
						this.$messagesBus.$emit("success", "Pomyślnie odrzucono ofertę", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się odrzucić oferty", errorResponse);
					});
			},

			approveOffer(offer) {
				this.$confirm("Czy na pewno chcesz zatwierdzić ofertę?", {
					icon: "warning",
					title: "Zatwierdzenie oferty",
					color: "info",
					width: 500,
				})
					.then(response => {
						if (response) {
							Offer.putApprove(this, offer.id, successResponse => {
									offer.offerStatus = "FINANCED";
									this.$messagesBus.$emit("success", "Oferta została zatwierdzona", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zatwierdzić oferty", errorResponse);
								});
						}
					});
			},

			updateOffersAfterProjectsGeneration(ids) {
				ids.forEach(id => this.offers.find(o => o.id === id).offerStatus = "APPROVED");
			},

			matchCauses() {
				this.correctionCauses.forEach(item => {
					let offer = this.offers.find(o => o.id === item.id);
					this.$set(offer, "correctionCause", item.correctionCause);
					this.$set(offer, "correctionDeadline", item.correctionDeadline);
				});
				this.causesMatched = true;
			},

			isOfferWithoutAnyEvaluation(offer) {
				return offer.formalEvaluations.length === 0
					&& offer.substantiveEvaluations.length === 0
					&& offer.finalEvaluation === null
					&& offer.agencyEvaluation === null
					&& offer.expertEvaluations.length === 0;
			},

			agencyEvaluationRemoved(offerId) {
				this.offers.find(el => el.id === offerId).agencyEvaluation = null;
				this.prepareWarningCodes();
			},

			formalEvaluationRemoved(offerId, evaluationIndex) {
				this.offers
					.filter(o => o.id === offerId)
					.map(o => this.$delete(o.formalEvaluations, evaluationIndex));
				this.prepareWarningCodes();
			},

			substantiveEvaluationRemoved(offerId, evaluationIndex) {
				this.offers
					.filter(o => o.id === offerId)
					.map(o => this.$delete(o.substantiveEvaluations, evaluationIndex));
				this.prepareWarningCodes();
			},

			finalEvaluationRemoved(offerId) {
				let offer = this.offers.find(el => el.id === offerId);
        offer.finalEvaluation = null;
        offer.offerStatus = 'SUBMITTED';
				this.prepareWarningCodes();
			},

			finalEvaluationBidderPreviewChanged(offerId, val) {
				this.offers.find(el => el.id === offerId).finalEvaluation.bidderPreviewEnabled = val;
			},

      finalEvaluationCorrectionRequested(finalEvaluationId) {
        let offer = this.offers.find(el => el.finalEvaluation && el.finalEvaluation.id === finalEvaluationId);
        if (offer && (offer.offerStatus === "RESERVED" || offer.offerStatus === "FINANCED")) {
          offer.offerStatus = "SUBMITTED";
        }
      },

			expertEvaluationRemoved(offerId, evaluationIndex) {
				this.offers
					.filter(o => o.id === offerId)
					.map(o => this.$delete(o.expertEvaluations, evaluationIndex));
				this.prepareWarningCodes();
			},

			prepareWarningCodes() {
				this.analyzeSubstantiveEvaluations();
				this.analyzeFormalEvaluations();
			},

			analyzeSubstantiveEvaluations() {
				this.warningCodes = [];
				let twoFinishedEvaluationOffers = this.offers.filter(o =>
					o.substantiveEvaluations.length === 2 &&
					o.substantiveEvaluations.filter(e => e.evaluationStatus === "FINISHED").length === 2,
				);

				twoFinishedEvaluationOffers.forEach(offer => {
					if (this.ratingSettings.booleanEvaluation) {
						this.checkForBooleanHighScoreDifference(offer);
					} else {
						this.checkForNonBooleanHighScoreDifference(offer);
					}
				});
			},

			analyzeFormalEvaluations() {
				let twoFinishedEvaluationOffers = this.offers.filter(o =>
					o.formalEvaluations.length === 2 &&
					o.formalEvaluations.filter(e => e.evaluationStatus === "FINISHED").length === 2,
				);

				twoFinishedEvaluationOffers.forEach(offer => {
					this.checkForFormalEvaluationDifference(offer);
				});
			},

			checkForBooleanHighScoreDifference(offer) {
				let subEvaluations = offer.substantiveEvaluations;
				if (subEvaluations[0].recommending !== subEvaluations[1].recommending) this.warningCodes.push(offer.offerCode);
			},

			checkForNonBooleanHighScoreDifference(offer) {
				let subEvaluations = offer.substantiveEvaluations;
				let evaluations = subEvaluations.map(e => e.evaluationPointsSum);
				evaluations.sort();
				let scoreDifference = Math.abs(evaluations[0] - evaluations[evaluations.length - 1]);
				if (scoreDifference > this.ratingSettings.maxScoreDifference) this.warningCodes.push(offer.offerCode);
			},

			checkForFormalEvaluationDifference(offer) {
				let formalEvaluations = offer.formalEvaluations;
				if (formalEvaluations[0].passed !== formalEvaluations[1].passed &&
					!this.warningCodes.includes(offer.offerCode)) {
					this.warningCodes.push(offer.offerCode);
				}
			},

			getAverage(values) {
				if (!values) return null;
				let count = values.length;
				if (count === 0) return 0;
				let sum = values.reduce((a, b) => a + b, 0) || 0;
				return sum / count;
			},

			resetSearch() {
				this.search.offerCode = "";
				this.search.evaluating = "";
				this.search.countryId = null;
				this.search.committeeId = null;
			},

			isNotSecretaryOrLeader() {
				return (this.roles.isDepartmentEmployee() || this.roles.isExpert()) &&
					(this.userDomainRole !== "SECRETARY" && this.userDomainRole !== "MAIN_SECRETARY" &&
					this.userDomainRole !== "LEADER" && this.userDomainRole !== "MAIN_LEADER");
			},

      loadContestOffers() {
        Offer.getSubmittedOfferListForSystemRole(this, this.contestData.id,
            successResponse => {
              this.offers = successResponse;
              this.getContestRatingSettings();
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować ofert", errorResponse);
            });
      },

      loadEvaluationSummary() {
        EvaluationSummary.get(this, this.$route.params.id, successResponse => {
          this.offersBelowQualification = successResponse.filter(offer =>
              !offer.isRejected && !offer.isInformal &&
              this.ratingSettings.qualificationThreshold > parseFloat(offer.averageSubstantiveEvaluationsPoints || 0));
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować ocen ofert", errorResponse);
        });
      },

      loadCorrectionCauses() {
        Offer.getSubmittedOffersCorrectionCauses(this, this.contestData.id,
            successResponse => {
              this.correctionCauses = successResponse;
              this.correctionCausesLoaded = true;
              if (this.offersLoaded && !this.causesMatched) this.matchCauses();
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
            });
      },

      loadContestStatus() {
        PublicContest.getStatus(this, this.contestData.id, successResponse => {
          this.contestData.contestStatus = successResponse.contestStatus;
        });
      },

      loadContestTerms() {
        PublicContest.getContestTerms(this, this.contestData.id,
            successResponse => {
              this.contestTerms = successResponse;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować warunków konkursu", errorResponse);
            });
      },

      loadEvaluationFormsInclusionStatuses() {
        PublicContest.getEvaluationFormsInclusionStatus(this, this.contestData.id,
            successResponse => {
              this.inclusionStatuses = successResponse.contestSchemaSet;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować danych o formularzach ocen", errorResponse);
            });
      },

      getContestRatingSettings() {
        PublicContest.getRatingSettings(this, this.contestData.id, successResponse => {
              this.ratingSettings = successResponse.ratingSettings;
              this.offersLoaded = true;
              if (this.correctionCausesLoaded && !this.causesMatched) this.matchCauses();
              this.loadEvaluationSummary();
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować parametrów oceny", errorResponse);
            });
      },

      getCountries() {
        TaskAccreditationCountry.getAvailableCountries(this, this.contestData.id, successResponse => {
          this.availableCountries = successResponse;
        });
      },

      loadAvailableCommittees() {
        Committee.getCommitteeNameId(this, this.contestData.id, successResponse => {
          this.availableCommittees = successResponse;
          this.availableCommittees.push({id: -1, name: "Nie przydzielone"});
        });
      }
		},

		mixins: [
			Dates,
			Initializator,
      Filters
		],
	};

</script>

<style scoped>
.v-icon {
	color: #fff !important;
}

.v-btn .v-btn__content .v-icon {
	color: #fff !important;
}

</style>
